// client-zip wrapper — streams selected blobs into a zip and triggers download.

import { downloadZip } from "client-zip";

export interface ZipEntry {
  name: string;
  blob: Blob;
}

/**
 * Build a streaming zip Response and trigger a browser download. Streams
 * directly to disk via <a download> + URL.createObjectURL, so we don't
 * buffer the full archive in memory.
 */
export async function downloadAsZip(
  entries: ZipEntry[],
  zipName = "overlay-output.zip",
): Promise<void> {
  if (entries.length === 0) {
    throw new Error("nothing to download");
  }
  // client-zip accepts iterables of { name, input } where input is Blob or Response.
  const stream = downloadZip(
    entries.map((e) => ({ name: e.name, input: e.blob })),
  );
  const zipBlob = await stream.blob();
  const url = URL.createObjectURL(zipBlob);
  try {
    const a = document.createElement("a");
    a.href = url;
    a.download = zipName;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    // Revoke after a tick so the download has a chance to start
    setTimeout(() => URL.revokeObjectURL(url), 100);
  }
}
